



























import { Component, Model, Prop, Vue } from 'nuxt-property-decorator';

export type ShowPlace = {
  value: string
  label: string
}

@Component
export default class ShowsFilter extends Vue {
  @Prop({ type: Array as () => ShowPlace[], required: true })
  places!: ShowPlace[]

  @Model('change', { default: null })
  activePlace!: string | null
}
